export type AllowedParams = Record<string, string[]>;

export const areParamsAllowed = (
  params: Record<string, string | undefined>,
  allowedParams?: AllowedParams
) =>
  Object.entries(allowedParams ?? {}).every(
    ([name, values]) =>
      params[name] === undefined || values.includes(params[name])
  );
